import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() { }

  constructName = (firstName:any,middleName:any,lastName:any, ) => {
    if(!middleName){
       middleName = '';
    };
    let nameArray = [firstName, middleName, lastName];
    nameArray = nameArray.filter(Boolean);
    return nameArray.join(' ').replace(/\b\w/g, l => l.toUpperCase());
  };
  trimString(str: String, maxLen: number) {
    return str = str.length > maxLen ? (str.slice(0, (maxLen - 3))) + '......' : str
  }

}
